import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ImpersonateHeader from 'components/nav/shared/ImpersonateHeader';
import DesktopHeader from 'components/nav/DesktopHeader';
import CommonModals from 'components/nav/shared/CommonModals';
import DesktopOnly from 'components/consumer/DesktopOnly';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import ConsumerHeaderMobileWrapper from './ConsumerHeaderMobileWrapper';
const ConsumerHeader = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ImpersonateHeader />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SuspenseWithLoader><CommonModals /></SuspenseWithLoader>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DesktopOnly fallback={<div className="DesktopHeader__primary-nav-section-filler bg-white z-[1002] max-[1023px]:hidden sticky top-0 min-h-[55px]" />}><DesktopHeader /></DesktopOnly>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t0}{t1}{t2}<MobileAndTabletOnly fallback={<><div className="ConsumerHeader__filler min-h-[3.75rem] min-[1024px]:min-h-0" /><div className="ConsumerHeader__skip-to-filler min-h-[3.75rem] min-[1024px]:min-h-0" /></>}><ConsumerHeaderMobileWrapper /></MobileAndTabletOnly></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default ConsumerHeader;